import React from 'react'
import { useState, useEffect, useContext } from 'react'
import { convertPrice, convertUTCDate, convertTime, datePhrase } from '../../../functions/Functions';
import {Errors} from '../../../partials/Partials';
import { LoadingContext } from '../../../partials/Context';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFilePdf} from '@fortawesome/free-regular-svg-icons';

function History({id, current_balance}) {
  const [transactions, setTransactions] = useState({})
  const [page, setPage] = useState(1);
  const {results, count} = transactions || '';
  const [errors, setErrors] = useState([]);
  const {setLoading} = useContext(LoadingContext)
  let list = [];
  let pages_count = Math.ceil(count/10)
  let pages_list = [];
  let end_btn = ''
  let start_btn = ''

  useEffect(() => {
      if (id) {
      setLoading(true)
      fetch(`/api/wallet_transactions/${id}/?page=${page}`).then(res => {
        if (res.ok) {
        res.json().then(
          data => {
            setTransactions(data)
          }
        )
        } else {
          setErrors(['Nie udało się pobrać historii transakcji'])
        }
        setLoading(false)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, page, current_balance])

  if (results) {
    results.forEach((result, index) => {
      const {created, description, value, real_type_name, balance, invoice_url} = result || ''
      let date = `${datePhrase(convertUTCDate(new Date(created)))} ${convertTime(new Date(created))}`
      list.push(
        <tr key={index}>
          <td id="date">{date}</td>
          <td id="description">{description}</td>
          <td id="pay-in">{value > 0 ? `+${convertPrice(value)} zł` : ''}</td>
          <td id="service-payment">{real_type_name === 'Transakcja prawnika' && value <= 0 ? `${convertPrice(value)} zł`: ''}</td>
          <td id="pay-out">{real_type_name !== 'Transakcja prawnika' && real_type_name !== "wallet transaction invoice" && value <= 0 ? `${convertPrice(value)} zł`: ''}</td>
          <td id="balance">{`${convertPrice(balance)} zł`}</td>
          <td id="bill" className="text-center">{invoice_url && real_type_name === 'wallet transaction invoice' ? 
            <a href={invoice_url} download>
              <FontAwesomeIcon icon={faFilePdf} className="pdf-icon"/>
            </a>
          :  ''
          }</td>
        </tr>
      )
    })
  }

  for (let i = 0; i < pages_count; i++) {
    if (i - page <= 1) {
      if (i - page <= 1 && i - page > -4) {
      pages_list.push(
        <button key={i}onClick={()=>setPage(i+1)} className={`btn btn-page ${page === i+1 ? 'btn-active': ''}`}>{i+1}</button>
      )
      end_btn =  <button key={pages_count*10+1} onClick={()=>setPage(pages_count)} className={`btn btn-page btn-radius-right ${page === pages_count ? 'btn-active': ''}`}>Koniec</button>
      }

      if (page > 3) {
        start_btn =  <button key={0} onClick={()=>setPage(1)} className={`btn btn-page btn-radius-left ${page === 1 ? 'btn-active': ''}`}>Początek</button>
      }

      if (pages_count - page < 3) {
        end_btn = ''
      }
    }
  }
  pages_list.push(end_btn)
  pages_list.unshift(start_btn)

  return (
    <div className="transactions">
      <h3 className="title">Operacje rozliczone</h3>
      <Errors errors={errors} />
      <div className='table-wrapper'>
      <table>
        <tbody>
        <tr>
          <th id="date">data</th>
          <th id="description">opis</th>
          <th id="pay-in">wpłata</th>
          <th id="service-payment">opłaty serwisowe</th>
          <th id="pay-out">wypłata</th>
          <th id="balance">saldo</th>
          <th id="bill">faktura</th>
        </tr>
        {list}
        </tbody>
      </table>
      </div>
      <div className="pages-list">
        {pages_list}
      </div>
    </div>
  )
}

export default History